/**
 * 计算两个时间的差值格式 120:47
 */
 export function getTimeDifference(beginTime, endTime) {
    console.log("进入了自定义getTime")
    var dateDiff = endTime.getTime() - beginTime.getTime();//时间差的毫秒数
    console.log("自定义getTime的开始时间：", endTime.getTime())
    console.log("自定义getTime的结束时间：", beginTime.getTime())
    console.log("自定义getTime的dateDiff", dateDiff)
    if (parseInt(dateDiff) < 0) {
        return "00:00"
    }
    var minDiff = Math.floor(dateDiff / (60 * 1000));//计算出相差分钟数
    var secondsDiff = (dateDiff/1000) % 60;//计算出相差秒数
    if (secondsDiff == 0) {
        secondsDiff = "00"
    } else if (secondsDiff>0&secondsDiff<10) {
        secondsDiff = '0'+secondsDiff+''
    }
    // var dayDiff = Math.floor(dateDiff / (24 * 3600 * 1000));//计算出相差天数
    // var leave1 = dateDiff % (24 * 3600 * 1000)    //计算天数后剩余的毫秒数
    // var hours = Math.floor(leave1 / (3600 * 1000))//计算出小时数
    // //计算相差分钟数
    // var leave2 = leave1 % (3600 * 1000)    //计算小时数后剩余的毫秒数
    // var minutes = Math.floor(leave2 / (60 * 1000))//计算相差分钟数
    // //计算相差秒数
    // var leave3 = leave2 % (60 * 1000)      //计算分钟数后剩余的毫秒数
    // var seconds = Math.round(leave3 / 1000)
    // console.log(" 相差 " + dayDiff + "天 " + hours + "小时 " + minutes + " 分钟" + seconds + " 秒")
    // return "相差 " + dayDiff + "天 " + hours + "小时 " + minutes + " 分钟";
    //这里要分钟数  120:30
    return minDiff+'' +':'+ secondsDiff;
  }
/**
 * 
 * @param {获取视频时间格式00:00} videoDuration 
 * @returns 
 */
export function getVideoTimeDifference(videoDuration) {
    console.log("进入了"+videoDuration)
    var dateDiff = parseInt(videoDuration);
    if (parseInt(dateDiff) < 0) {
        return "00:00"
    }
    var minDiff = Math.floor(dateDiff / 60);//计算出相差分钟数
    var secondsDiff = dateDiff % 60;//计算出相差秒数
    if (secondsDiff == 0) {
        secondsDiff = "00"
    } else if (secondsDiff>0&secondsDiff<10) {
        secondsDiff = '0'+secondsDiff+''
    }
    return minDiff+'' +':'+ secondsDiff;
}
export function isNull(str) {
    if (str === null || str === undefined || str.length === 0) {
        return true
    }
    return false
}